/**
 * Email Credentials Types
 * Types for bulk credential email sending workflow
 */
/**
 * Column name variations for flexible matching
 */
export const COLUMN_MAPPINGS = {
    v5UserId: [
        "V5UserId",
        "V5 UserId",
        "V5 User Id",
        "UserId",
        "User Id",
        "User ID",
        "v5_user_id",
    ],
    identityId: [
        "IdentityId",
        "Identity Id",
        "Identity ID",
        "identity_id",
    ],
};
